/* Makes the #ucover launch overlay escapable. It was a trap.

   THE BUG (found 10 Aug, reported as "sometimes it gets stuck").
   layout/luma.liquid builds #ucover and binds:
       ov.querySelector('.ucbtn').addEventListener('click', hide);
       ov.addEventListener('click', function(e){ if (e.target === ov) hide(); });
   Then other code REPLACES the overlay's innerHTML to swap in the launch copy
   ("LUMA NYC, redesigned" instead of the layout's "Coming soon"). Replacing innerHTML
   destroys the original .ucbtn node — and with it the only reliable close handler. What
   is left is a backdrop listener that fires only on a pixel-exact hit of the overlay
   itself; clicking the text, the heading or the box does nothing. There is no Escape
   key and no X. Meanwhile the layout opens this overlay on EVERY header link
   (Shop / Bestsellers / Discover / About), capture-phase with preventDefault.

   So a shopper clicks a nav item, gets a full-screen overlay, and can be stuck behind it.
   That is a hard launch blocker, not a cosmetic issue.

   THE FIX: close handlers that cannot be destroyed by a re-render — delegated on
   document, plus Escape, plus a real X button that is re-added if the content is
   replaced again. Nothing here re-opens or suppresses the overlay; it only guarantees
   the shopper can always get out. */
(function(){
  var ID = 'ucover';

  function ov(){ return document.getElementById(ID); }

  function hide(){
    var o = ov();
    if (!o) return;
    o.style.setProperty('display','none','important');
  }

  function isOpen(){
    var o = ov();
    return !!o && getComputedStyle(o).display !== 'none';
  }

  /* 1. delegated close — survives any number of innerHTML rebuilds */
  document.addEventListener('click', function(e){
    var o = ov();
    if (!o || !isOpen()) return;

    /* the CTA, whatever node currently represents it */
    if (e.target.closest && e.target.closest('#'+ID+' .ucbtn, #'+ID+' .lucx')) {
      e.preventDefault();
      hide();
      return;
    }
    /* anywhere outside the content box counts as a backdrop click, not just an
       exact hit on the overlay element */
    if (o.contains(e.target) && !(e.target.closest && e.target.closest('#'+ID+' .ucbox'))) {
      hide();
    }
  }, true);

  /* 2. Escape always works */
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && isOpen()) hide();
  });

  /* 3. a real close button, re-added whenever the overlay content is rebuilt */
  function ensureX(){
    var o = ov();
    if (!o) return;
    var box = o.querySelector('.ucbox') || o.firstElementChild;
    if (!box || box.querySelector('.lucx')) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'lucx';
    x.setAttribute('aria-label','Close');
    x.innerHTML = '&#215;';
    x.style.cssText = 'position:absolute;top:-8px;right:-8px;width:40px;height:40px;'
      + 'background:none;border:0;color:#fff;font-size:26px;line-height:1;cursor:pointer;'
      + 'opacity:.75;padding:0;z-index:2';
    box.appendChild(x);
  }

  if (document.body) ensureX();
  document.addEventListener('DOMContentLoaded', ensureX);
  window.addEventListener('load', ensureX);
  [200, 700, 1500, 3000].forEach(function(d){ setTimeout(ensureX, d); });

  /* the overlay content gets rebuilt asynchronously, so watch for it */
  function observe(){
    if (!document.body) return;
    new MutationObserver(function(){ ensureX(); })
      .observe(document.body, { childList:true, subtree:true });
  }
  if (document.body) observe(); else document.addEventListener('DOMContentLoaded', observe);
})();